module.exports = __webpack_public_path__ + "static/media/lime-sms-tracking.396e4d6f.svg";